import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const corporateActionsServiceUserPrincipleAxios = () => (config) => axios.get(`${host()}/user`, config);
export const corporateActionsServiceUserRolesAxios = () => (config) => axios.get(`${host()}/user/roles`, config);
